import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { indexOf } from 'lodash';
import { environment } from '../../../../../../../../environments/environment';
var TabPermissionsComponent = /** @class */ (function () {
    function TabPermissionsComponent(authenticationService) {
        this.authenticationService = authenticationService;
        this.currentlyExpandedCategoryIndex = null;
        this.isProduction = environment.production;
    }
    TabPermissionsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.categoriesArray.controls.forEach(function (category) {
                    _this.onPermissionSelectionChange(category);
                });
                return [2 /*return*/];
            });
        });
    };
    TabPermissionsComponent.prototype.switchCategoryExpansion = function (category) {
        var newExpandedValue = !category.get('expanded').value;
        category.get('expanded').setValue(newExpandedValue);
        if (newExpandedValue) {
            if (this.currentlyExpandedCategoryIndex !== null) {
                this.categoriesArray.at(this.currentlyExpandedCategoryIndex).get('expanded').setValue(false);
            }
            this.currentlyExpandedCategoryIndex = indexOf(this.categoriesArray.controls, category);
        }
        else {
            this.currentlyExpandedCategoryIndex = null;
        }
    };
    TabPermissionsComponent.prototype.onCategorySelectionChange = function (checked, category) {
        category.get('indeterminate').setValue(false);
        category.get('permissions').controls.forEach(function (permission) {
            permission.get('checked').setValue(checked);
        });
    };
    TabPermissionsComponent.prototype.onPermissionSelectionChange = function (category) {
        var permissionLength = category.get('permissions').controls.length;
        var checkedPermissionsCount = category
            .get('permissions')
            .controls.filter(function (permission) { return permission.get('checked').value; }).length;
        var checked = permissionLength === checkedPermissionsCount;
        var indeterminate = !checked && checkedPermissionsCount > 0;
        category.get('checked').setValue(checked);
        category.get('indeterminate').setValue(indeterminate);
    };
    TabPermissionsComponent.prototype.toggleCategory = function (category) {
        var newCheckedValue = !category.get('checked').value;
        category.get('checked').setValue(newCheckedValue);
        this.onCategorySelectionChange(newCheckedValue, category);
    };
    TabPermissionsComponent.prototype.togglePermission = function (category, permission) {
        var newCheckedValue = !permission.get('checked').value;
        permission.get('checked').setValue(newCheckedValue);
        this.onPermissionSelectionChange(category);
    };
    TabPermissionsComponent.prototype.isVisiblePermissionCategory = function (category) {
        var value = category.getRawValue();
        if (!value.featureFlag) {
            return true;
        }
        return this.authenticationService.hasFlags(value.featureFlag);
    };
    return TabPermissionsComponent;
}());
export { TabPermissionsComponent };
